angular.module('study.dashboard').component('progressBar', {
    templateUrl: 'modules/dashboard/components/progress-bar/template.html',
    bindings: {
        completePercent: '<',
        overduePercent: '<',
        pendingPercent: '<',
    },
});
